import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';
import moment from 'moment';

import StoreS3 from '../../util/StoreS3.jsx';
import ListWorksetItems from './ListWorksetItems.jsx';
import DataRow from './DataRow.jsx';

const ContentWrapper = styled.div`
    margin: 0.25rem 1.5rem 1rem;
`;

const VimeoLinkGroup = styled.div`
    display: inline-block;
    margin-left: 0.5rem;
`;

const VimeoLink = styled.div`
    display: inline-block;
    margin: 0 0.5rem;
    font-style: italic;
    font-size: 0.9rem;
    color: blue;
    vertical-align: top;
`;

export class WorksetItemDetail extends Component {

    static propTypes = {
        workset_item: PropTypes.object.isRequired
    }

    state = {
        workset_item: this.props.workset_item,
        in_item_add: false
    };

    confirm_field_value_edit = (edit_field_name, new_value) => {
        const workset_item = this.state.workset_item;
        workset_item["updated"] = moment().format();
        workset_item[edit_field_name] = new_value;
        StoreS3.put_file(workset_item.path, JSON.stringify(workset_item, undefined, 2));
        this.setState({
            workset_item: workset_item,
        })
    }

    make_vimeo_extra() {
        const value = String(this.state.workset_item["vimeo-id"])
        if (isNaN(value)) {
            return <span />;
        }
        const vimeo_url = "https://vimeo.com/" + value;
        const settings_url = "https://vimeo.com/manage/" + value + "/general";
        const discovery_url = "https://vimeo.com/manage/" + value + "/distribution#discovery";
        const analytics_url = "https://vimeo.com/manage/" + value + "/analytics";
        const links = [
            {title: "view", url: vimeo_url},
            {title: "edit", url: settings_url},
            {title: "discovery", url: discovery_url},
            {title: "analytics", url: analytics_url},
        ]
        const all_links = links.map(link => {
            return <VimeoLink key={"vimeo_link_" + link.title} onClick={e => {
                var win = window.open(link.url, '_blank');
                win.focus();
            }}>{link.title}</VimeoLink>
        });
        return <VimeoLinkGroup>
            {all_links}
        </VimeoLinkGroup>
    }

    render() {
        const vimeo_extra = this.make_vimeo_extra();
        return <ContentWrapper>
            <DataRow
                item_data={this.state.workset_item}
                name={"index"}
                can_edit={true}
                update_item={new_value => this.confirm_field_value_edit ("index", new_value)}
            />
            <DataRow
                item_data={this.state.workset_item}
                name={"value"}
                can_edit={true}
                field_type={"textarea"}
                update_item={new_value => this.confirm_field_value_edit ("value", new_value)}
            />
            <DataRow
                item_data={this.state.workset_item}
                name={"vimeo-id"}
                can_edit={true}
                field_extra={vimeo_extra}
                update_item={new_value => this.confirm_field_value_edit ("vimeo-id", new_value)}
            />
            <ListWorksetItems workset={this.state.workset_item} />
        </ContentWrapper>
    }
}

export default WorksetItemDetail;

